<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ReservationLayout',
}
</script>
